import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { portfolio } from '../mock';
import { ArrowUpRight } from 'lucide-react';

const images = {
  1: 'https://images.unsplash.com/photo-1579389083078-4e7018379f7e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBwcm9mZXNzaW9uYWwlMjB3b3JraW5nJTIwbGFwdG9wJTIwY2xlYW4lMjBiYWNrZ3JvdW5kfGVufDB8fHx8MTc4NDg5OTA5N3ww&ixlib=rb-4.1.0&q=85',
  2: 'https://images.pexels.com/photos/5942722/pexels-photo-5942722.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  3: 'https://images.unsplash.com/photo-1553877522-43269d4ea984?w=900&h=700&fit=crop',
  4: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=900&h=700&fit=crop',
};

export default function Portfolio() {
  const targetRef = useRef(null);
  const { scrollYProgress } = useScroll({ target: targetRef });
  const x = useTransform(scrollYProgress, [0, 1], ['2%', '-62%']);

  return (
    <section id="portfolio" ref={targetRef} className="relative h-[300vh] bg-[#050A08]" data-testid="portfolio-section">
      <div className="sticky top-0 h-screen flex flex-col justify-center overflow-hidden">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 w-full mb-12">
          <span className="inline-block text-emerald-400 font-semibold text-sm uppercase tracking-[0.25em] mb-5">
            / Proven Results
          </span>
          <h2 className="font-display text-4xl md:text-6xl font-black text-white leading-[0.95] max-w-3xl">
            Real businesses.<br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-lime-400">Real transformation.</span>
          </h2>
        </div>

        <motion.div style={{ x }} className="flex gap-6 pl-6 lg:pl-12">
          {portfolio.map((project) => (
            <div
              key={project.id}
              className="group relative h-[440px] w-[85vw] md:w-[600px] flex-shrink-0 rounded-3xl overflow-hidden border border-white/[0.06]"
              data-testid={`portfolio-card-${project.id}`}
            >
              <img
                src={images[project.id]}
                alt={project.client}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#050A08] via-[#050A08]/70 to-transparent" />

              <div className="absolute inset-0 p-10 flex flex-col justify-end">
                <span className="inline-flex w-fit items-center px-3 py-1 rounded-full bg-emerald-500/20 border border-emerald-500/30 text-emerald-300 text-xs font-semibold mb-4">
                  {project.industry}
                </span>
                <h3 className="font-display text-3xl font-bold text-white mb-2">{project.client}</h3>
                <p className="text-slate-300 mb-6">{project.project}</p>
                <div className="flex items-center justify-between border-t border-white/10 pt-5">
                  <span className="font-display text-2xl font-black text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-lime-400">
                    {project.result}
                  </span>
                  <div className="w-11 h-11 rounded-full bg-emerald-500 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <ArrowUpRight className="w-5 h-5 text-[#04120C]" />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
